import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  desktopSignIn: {
    defaultMessage: 'Can’t scan the QR code? Click here',
    id: 'AddCredentialsPage.anotherDevice',
  },
  qrCodeCaptionPiS: {
    defaultMessage: 'QR code for signing payment on your phone',
    id: 'SubmitHandoffPay.qrCodeCaptionPiS',
  },
  qrCodeInstructions: {
    defaultMessage:
      'To continue, scan the QR code with your <b>camera app</b> or <b>QR scanner app</b>.',
    id: 'SubmitHandoffPay.qrCodeInstructions',
  },
});
